import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReviewComponent} from './review.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ReviewSummaryComponent} from './review-summary/review-summary.component';
import {FirstReviewComponent} from './first-review/first-review.component';
import {WriteReviewComponent} from './write-review/write-review.component';
import {MediaModule} from '@spartacus/storefront';
import {ReviewPreviewComponent} from './review-preview/review-preview.component';

import {WriteReviewDialogComponent} from '@app/product/details/review/write-review/write-review-dialog/write-review-dialog.component';

import {StarRatingComponent} from './star-rating/star-rating.component';
import {ReviewAnswersComponent} from './review-answers/review-answers.component';

import {A11yModule} from '@angular/cdk/a11y';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductViewComponent: {
          component: ReviewComponent,
        },
      },
    }),
    I18nModule,
    MediaModule,
    A11yModule,
    ReviewComponent,
    ReviewSummaryComponent,
    FirstReviewComponent,
    WriteReviewComponent,
    ReviewPreviewComponent,
    WriteReviewDialogComponent,
    StarRatingComponent,
    ReviewAnswersComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ReviewComponent,
    ReviewSummaryComponent,
    FirstReviewComponent,
    WriteReviewComponent,
    StarRatingComponent,
    WriteReviewDialogComponent,
  ],
})
export class ReviewModule {}
